import { render, staticRenderFns } from "./KStatusChart.vue?vue&type=template&id=4bbd3e18&scoped=true"
import script from "./KStatusChart.vue?vue&type=script&lang=ts"
export * from "./KStatusChart.vue?vue&type=script&lang=ts"
import style0 from "./KStatusChart.scss?vue&type=style&index=0&id=4bbd3e18&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbd3e18",
  null
  
)

export default component.exports